import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GenerateGroupInvoiceService {
  baseUrl = environment.baseUrl + 'GenerateGroupInvoiceNumber';
  constructor(private http: HttpClient) { }
  generateInvoice(): Observable<any>{
    return this.http.get(this.baseUrl);
  }
}
